import { cva, type VariantProps } from "class-variance-authority"
import * as React from "react"

import { cn } from "../lib/utils"

const textButtonVariants = cva(
  "inline-flex items-center justify-center gap-1 text-body-md font-semibold underline underline-offset-2 transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50",
  {
    variants: {
      variant: {
        primary: "text-primary hover:text-primary/80",
        secondary: "text-secondary hover:text-secondary/80",
        neutral: "text-text hover:text-gray",
      },
    },
    defaultVariants: {
      variant: "primary",
    },
  }
)

export interface TextButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof textButtonVariants> {}

const TextButton = React.forwardRef<HTMLButtonElement, TextButtonProps>(
  ({ className, variant, ...props }, ref) => (
    <button ref={ref} className={cn(textButtonVariants({ variant, className }))} {...props} />
  )
)
TextButton.displayName = "TextButton"

export { TextButton, textButtonVariants }
